export const filterTransactions = (
  transactions,
  searchTerm,
  filterType,
  filterStatus
) => {
  const normalizedSearchTerm = searchTerm.trim().toLowerCase();

  return transactions.filter((transaction) => {
    const matchesType =
      filterType === 'all' ||
      transaction.type?.toUpperCase() === filterType.toUpperCase();
    const matchesStatus =
      filterStatus === 'all' ||
      transaction.status?.toUpperCase() === filterStatus.toUpperCase();
    const searchableValues = [
      transaction.user?.fullName,
      transaction.user?.email,
      transaction.user?.uid,
      transaction.user?.id,
      transaction.userId,
      transaction.id,
      transaction.currency,
    ];
    const matchesSearch = searchableValues.some((value) =>
      String(value ?? '').toLowerCase().includes(normalizedSearchTerm)
    );

    return matchesType && matchesStatus && matchesSearch;
  });
};
